import React, { useEffect } from 'react';
import { useGlobalContext } from '../context/GlobalContext';
import { t } from 'i18next';
import { Button } from 'dstill';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {

  const { dispatch, state } = useGlobalContext();
  const { error } = state;

  useEffect(() => {
    window.addEventListener('error', (event) => {
      dispatch({ type: "LOG_ERROR", error: { show: true, type: "alert", displayErrorMessage: "uncaught error", rawErrorMessage: event.error } })
    });

    return () => {
      window.removeEventListener('error', (event) => { dispatch({ type: "LOG_ERROR", error: { show: false, type: "alert", displayErrorMessage: "", rawErrorMessage: null } }) });
    };
  }, [error.show, dispatch]);

  const handleRefreshPage = () => {
    window.location.href = '/pages/print-connect-registration-form'
  };

  if (error.show && error.type === "fatal") {
    return (
      <div className="xl:container mx-auto px-3 lg:px-6 mb-6 pt-12 flex flex-col items-center h-[100vh]">
        <div className="mb-5">
          <label className="text-xl">{t("app.defaultFaltalError")}</label>
        </div>
        <p>{t("app.defaultUserFriendlyErrorMessgae1")}</p>
        <p>{t("app.defaultUserFriendlyErrorMessgae2")}</p>
        <br />
        {process.env.NODE_ENV != "production" &&
          <div>
            {
              Object.entries(error).map(([key, value]) => (
                <div key={key}>
                  <strong>{key}:</strong> {JSON.stringify(value, null, 2).replace(/\\/g, '')}
                </div>
              ))
            }
          </div>
        }
        <br />
        <div>
          <Button
            name="refreshOnErrorButton"
            title="Refresh Page"
            color="secondary"
            role="button"
            onClick={handleRefreshPage}>
            {t('app.refreshOnErrorButtonLabel')}
          </Button>
        </div>
      </div>
    )
  }

  return <>{children}</>;
};

export default ErrorBoundary;
